import React from "react";
import { useIntl } from "react-intl";
export function Text({ id, data = {}, className }) {
    const { formatMessage } = useIntl();
    return <span className={className || ""}> {formatMessage({ id: id }, data)} </span>;
}
//# sourceMappingURL=text.jsx.map